(() => {
  if (window.MayLondonImageGuard) return;
  window.MayLondonImageGuard = true;
  let config = {};
  try { config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}'); } catch (_) {}
  if (config.contentProtection === false || config.designMode || window.Shopify?.designMode) return;
  document.documentElement.classList.add('ml-image-protection');
  const imageTarget = event => event.composedPath().some(target => target instanceof Element &&
    (target.matches('img, picture, .product-watermark') || target.matches('canvas[data-protected-image]')));
  for (const type of ['contextmenu', 'dragstart']) document.addEventListener(type, event => {
    if (imageTarget(event) && !event.target.closest('input, textarea, [contenteditable="true"]')) event.preventDefault();
  });
})();
